/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Ledgeramount2Inputs */

const zh_adminsubs_ledgeramount2 = /** @type {(inputs: Adminsubs_Ledgeramount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`变动`)
};

const en_adminsubs_ledgeramount2 = /** @type {(inputs: Adminsubs_Ledgeramount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change`)
};

const es_adminsubs_ledgeramount2 = /** @type {(inputs: Adminsubs_Ledgeramount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambio`)
};

/**
* | output |
* | --- |
* | "Change" |
*
* @param {Adminsubs_Ledgeramount2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_ledgeramount2 = /** @type {((inputs?: Adminsubs_Ledgeramount2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Ledgeramount2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_ledgeramount2(inputs)
	if (locale === "en") return en_adminsubs_ledgeramount2(inputs)
	return es_adminsubs_ledgeramount2(inputs)
});
export { adminsubs_ledgeramount2 as "adminSubs_ledgerAmount" }